import React from "react";
import styles from "./Progress.module.scss";
import spinnerImage from "../../assets/images/spinner-solid.svg";

export const Progress = () => {
  return (
    <div className={styles.outer_container}>
      <img className={styles.progress_image} src={spinnerImage} alt="Processing logo" />
    </div>
  );
};
